import {useEffect} from 'react';
import {useBlocker} from 'react-router';

/**
 * Keeps this page where it is: any in-app navigation away from `path` (a
 * picked result, a link in an Ask answer) opens in a new window instead, so
 * the search app's window stays the search. From an installed app that's the
 * browser, or the full app if it's installed and captures links.
 */
export const useOpenOutsideInNewWindow = (path: string) => {
  const blocker = useBlocker(({nextLocation}) => nextLocation.pathname !== path);

  useEffect(() => {
    if (blocker.state !== 'blocked') return;
    const {pathname, search, hash} = blocker.location;
    window.open(`${pathname}${search}${hash}`, '_blank', 'noopener,noreferrer');
    blocker.reset();
  }, [blocker]);
};
